import PageDictionaryCreate from './PageDictionaryCreate';



export default PageDictionaryCreate;
